import APIServiceLookUp from './serviceAPI';
import { MAIN_API_URL } from './models/AppConstent';

export default class ServiceInventory {
    lookupService = new APIServiceLookUp();

    async setInvItem(body) {
        var serviceType = "POST";
        var url = `${MAIN_API_URL}inventory/setInvItem`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, '');
    }

    async updateInvItem(body) {
        var serviceType = "POST";
        var url = `${MAIN_API_URL}inventory/updateInvItem`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, '');
    }

    async getInvItemById(body) {
        var serviceType = "POST";
        var url = `${MAIN_API_URL}inventory/getInvItemById`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, '');
    }

    async delInvItem(body) {
        var serviceType = "POST";
        var url = `${MAIN_API_URL}inventory/delInvItem`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, '');
    }

    async getAllInvItem(body) {
        var serviceType = "POST";
        var url = `${MAIN_API_URL}inventory/getAllInvItem`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, '');
    }

    async getAllBOM(body) {
        var serviceType = "POST";
        var url = `${MAIN_API_URL}bom/getAllBOM`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, '');
    }

    async setBOM(body) {
        var serviceType = "POST";
        var url = `${MAIN_API_URL}bom/setBOM`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, '');
    }

    async updateBOM(body) {
        var serviceType = "POST";
        var url = `${MAIN_API_URL}bom/updateBOM`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, '');
    }

    async delBOM(body) {
        var serviceType = "POST";
        var url = `${MAIN_API_URL}bom/delBOM`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, '');
    }

    async setInvTransaction(body) {
        var serviceType = "POST";
        var url = `${MAIN_API_URL}inventory/setInvTransaction`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, '');
    }

    async getAllTransaction(body) {
        var serviceType = "POST";
        var url = `${MAIN_API_URL}inventory/getAllTransaction`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, '');
    }

    async getAllTansByAcc(body) {
        var serviceType = "POST";
        var url = `${MAIN_API_URL}inventory/getAllTansByAcc`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, '');
    }
}